import { render, staticRenderFns } from "./ListQuotes.vue?vue&type=template&id=5bd0086c&"
import script from "./ListQuotes.vue?vue&type=script&lang=js&"
export * from "./ListQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports